import { fetcher } from '@commenda/utils';

export interface UpdateBillingSkuDependencyParams {
  sellTogether: boolean;
}

export const updateBillingSkuDependency = async (
  skuId: string,
  dependencyId: string,
  params: UpdateBillingSkuDependencyParams
) => {
  return fetcher(
    `commenda-billing/catalog/skus/${skuId}/dependencies/${dependencyId}`,
    { method: 'PATCH', body: params }
  );
};
